module.exports = __webpack_public_path__ + "media/images/vp/parallax.new.03.a-6ce4035bb55a54dc5ae674ea525524d7.svg";